module.exports = __webpack_public_path__ + "static/media/image_5.1b66c9ae.png";